import React from "react";

const PublicPageMock = (props) => {
  console.log("render public page");
  return <div>Public page</div>;
};

export default PublicPageMock;
